import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { CreateSellerAction } from '@core/states/dealer/dealer.actions';
import { Store } from '@ngxs/store';
import { noIllegalCharactersValidator } from '@sales/validators/no-illegal-characters-validator';
import { IceButtonComponent } from '@app/shared/components/atoms/ice-button/ice-button.component';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { Regex } from '@app/shared/enums/regex';
import { IceAlertComponent } from '@app/shared/components/molecules/ice-alert/ice-alert.component';

@Component({
  selector: 'app-create-seller-dialog',
  templateUrl: './create-seller-dialog.component.html',
  styleUrls: ['./create-seller-dialog.component.scss'],
  imports: [
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
    MatDialogActions,
    IceButtonComponent,
    MatDialogClose,
    IceAlertComponent,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class CreateSellerDialogComponent {
  private store = inject(Store);
  dialogRef = inject<MatDialogRef<CreateSellerDialogComponent>>(MatDialogRef);

  form: FormGroup = new FormGroup({
    firstName: new FormControl('', [Validators.required, noIllegalCharactersValidator()]),
    lastName: new FormControl('', [Validators.required, noIllegalCharactersValidator()]),
    email: new FormControl('', [Validators.required, Validators.pattern(Regex.Email)]),
  });

  createSeller() {
    this.store.dispatch(
      new CreateSellerAction({
        firstName: this.form.controls.firstName.value,
        lastName: this.form.controls.lastName.value,
        email: this.form.controls.email.value,
      })
    );
    this.dialogRef.close();
  }

  abort() {
    this.dialogRef.close();
  }
}
